// https://en.wikipedia.org/wiki/ISO_4217
export enum Currency {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
}

export enum PricingCompanySizeE {
  '1-20' = '1-20',
  '21-50' = '21-50',
  '51-100' = '51-100',
  '101-150' = '101-150',
  '151-250' = '151-250',
  '251-500' = '251-500',
  '501+' = '501',
}

export type PricingCompanySize = PricingCompanySizeE | string;
